import { emptyApi } from "./emptyApi";

export type AgentSession = {
  channel_url: string;
  company_group_id: string;
  company_entity_id: string;
  user_email: string;
  active_outcome: string | null;
};

export const inkleAssistantApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getAgentSession: build.query<AgentSession | null, { channelUrl: string }>({
      query: ({ channelUrl }) => ({
        url: `/api/inkle/inkle_assistant/channel/${channelUrl}/session/`,
      }),
      providesTags: (_res, _err, { channelUrl }) => [
        { type: "AGENT_SESSION", id: channelUrl },
      ],
    }),

    updateAgentSessionEntity: build.mutation<
      AgentSession,
      { channelUrl: string; companyEntityId: string }
    >({
      query: ({ channelUrl, companyEntityId }) => ({
        url: `/api/inkle/inkle_assistant/channel/${channelUrl}/session/`,
        method: "PUT",
        body: { company_entity_id: companyEntityId },
      }),
      invalidatesTags: (_res, _err, { channelUrl }) => [
        { type: "AGENT_SESSION", id: channelUrl },
      ],
    }),
  }),
});

export const {
  useGetAgentSessionQuery,
  useLazyGetAgentSessionQuery,
  useUpdateAgentSessionEntityMutation,
} = inkleAssistantApi;
